<div
  class="popover"
  nz-popover
  [nzPopoverContent]="contentTemplate"
  [nzPopoverOverlayClassName]="'advanced-tooltip'"
  nz-tooltip
>
  <span nz-icon style="font-size: 16px" class="material-icons-outlined">help_outline</span>
</div>

<ng-template #contentTemplate>
  @if (!isMarkdown) {
    <div class="popover-content">{{ popover }}</div>
  } @else {
    <div class="popover-content" [innerHTML]="popover | markdownIt"></div>
  }
  <ng-content></ng-content>
</ng-template>
